export default __webpack_public_path__ + "static/media/isa-sign-expo-2025.ae18ccdb.png";